// import { Message } from 'iview';
// import 'iview/dist/styles/iview.css';

// // import VeeValidate from './lib/vee-validate';
// import loading from './packages/loading';



import Pagination from './components/Pagination.vue';
import Sidebar from './components/Sidebar.vue';
import FormItem from './components/FormItem.vue';
import BtnSelect from "./components/BtnSelect.vue";
import BtnSelectItem from "./components/BtnSelectItem.vue";
import Tree from "./components/Tree.vue";
import Step from "./components/Step.vue";
import Radio from "./components/Radio.vue";
import InputFile from "./components/InputFile.vue";
import InputFile1 from "./components/InputFile1.vue";
import Upload from "./components/Upload.vue";
import Upload1 from "./components/Upload1.vue";
import CityPicker from './components/city-picker/CityPicker.vue'
import Loading from "./components/Loading.vue";

import confirm from './packages/confirm'; // 确认框
import loading from './packages/loading'; // 确认框


const components = [
    Pagination,
    FormItem,
    Sidebar,
    BtnSelect,
    BtnSelectItem,
    Tree,
    Step,
    Radio,
    InputFile,
    InputFile1,
    Upload,
    Upload1,
    CityPicker,
    Loading,
];



const install = function (Vue, opts = {}) {
    components.forEach(component => {
        Vue.component(component.name, component);
    });

    Vue.prototype.$xc = {
        confirm,
        loading,
    };
}

/* istanbul ignore if */
if (typeof window !== 'undefined' && window.Vue) {
    install(window.Vue);
}

export default {
    version: '1.0.0',
    install,
    confirm,
    loading,
}
